// extracted by mini-css-extract-plugin
export default {"checkRow":"LinkAlertModal_checkRow__kkALf","checkText":"LinkAlertModal_checkText__UlxEX","linkConfirmButton":"LinkAlertModal_linkConfirmButton__1zuWS"};